export default __webpack_public_path__ + "static/media/abtBlaze.6e76d73f.jpg";